import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, output, OutputEmitterRef} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {UxIcon} from "@trumpf/ux.ui-angular";

@Component({
  selector: 'app-app-menu',
  imports: [
    TranslatePipe,
    UxIcon
  ],
  templateUrl: './app-menu.component.html',
  styleUrl: './app-menu.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMenuComponent {
  public routerLinkActivated: OutputEmitterRef<void> = output<void>();

  protected appMenu: ({ label: string; icon: string; link: string })[] = [
    {
      label: 'Shop',
      icon: 'app:cart-cogs',
      link: 'https://www.shop.trumpf.com/',
    },
    {
      label: 'Service-App',
      icon: 'app:wrench',
      link: 'https://www.trumpf.com/?id=4236',
    },
    {
      label: 'Smart-Factory Suite',
      icon: 'app:factory',
      link: 'https://www.trumpf.com/?id=6916',
    },
  ];
}
